// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2f34005a","455":"8d978ccc","977":"ab185fb2"}[chunkId] + ".chunk.js";
};